// extracted by mini-css-extract-plugin
export default {"card":"Calculator_card__yBq2c","calc_grid":"Calculator_calc_grid__wI4jg"};